import { ref } from 'vue'

import { defineStore } from 'pinia'

export const useCareHealthBannerStore = defineStore(
  'care-health-banner',
  () => {
    const isCareHealthBannerDisplayed = ref(true)

    function closeCareHealthBanner() {
      isCareHealthBannerDisplayed.value = false
    }

    return {
      closeCareHealthBanner,
      isCareHealthBannerDisplayed,
    }
  },
)
